var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-takeaway",class:{
    'highlighted': _vm.highlighted,
  }},[_c('icon-card',{attrs:{"highlighted":_vm.highlighted},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('icon',{staticClass:"icon",attrs:{"name":"trophy","variant":"326ff0"}})]},proxy:true},{key:"title",fn:function(){return [_vm._v("\n      Key Takeaway\n    ")]},proxy:true}])},[_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }